import { render, staticRenderFns } from "./PhoenixResponsiveImage.vue?vue&type=template&id=8bdff39a"
import script from "./PhoenixResponsiveImage.vue?vue&type=script&lang=js"
export * from "./PhoenixResponsiveImage.vue?vue&type=script&lang=js"
import style0 from "./PhoenixResponsiveImage.vue?vue&type=style&index=0&id=8bdff39a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports